export default __webpack_public_path__ + "static/media/hair-0-4.f5fce378.svg";